import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { useDrop } from 'react-dnd';
import { GridCellProps, DragItem } from '../types';
import { ITEM_TYPE } from '../constants';

export const GridCell: React.FC<GridCellProps & {
    onWidgetDrop: (dragItem: DragItem, column: number, row: number) => void;
    onWidgetDelete: (item: any) => void;
}> = ({ 
    column, 
    row, 
    item, 
    children, 
    onWidgetDrop,
    onWidgetDelete
}) => {
    const [{ isOver, canDrop }, drop] = useDrop(() => ({
        accept: ITEM_TYPE,
        drop: (dragItem: DragItem) => {
            onWidgetDrop(dragItem, column, row);
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop()
        })
    }));

    const isOccupied = !!item;
    
    return (
        <Box
            ref={drop}
            sx={{
                gridColumn: column,
                gridRow: row,
                border: '1px solid',
                borderColor: isOver ? 'primary.main' : 'divider',
                backgroundColor: isOver && canDrop ? 'primary.light' : 
                               isOccupied ? 'action.selected' : 'transparent',
                minHeight: '120px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                opacity: isOver && canDrop ? 0.8 : 1,
                '&:hover': {
                    backgroundColor: isOccupied ? 'action.selected' : 'action.hover'
                }
            }}
        >
            {children}
            {isOccupied && item && (
                <IconButton
                    size="small"
                    sx={{ position: 'absolute', top: 4, right: 4 }}
                    onClick={(e) => {
                        e.stopPropagation();
                        onWidgetDelete(item);
                    }}
                >
                    <Delete fontSize="small" />
                </IconButton>
            )}
        </Box>
    );
};